const ELLIPSIS = "…";

const DEFAULT_HEAD_LENGTH = 18;
const DEFAULT_TAIL_LENGTH = 12;

type Options = {
  headLength?: number;
  tailLength?: number;
};

export function truncateMiddle(
  value: string,
  {
    headLength = DEFAULT_HEAD_LENGTH,
    tailLength = DEFAULT_TAIL_LENGTH,
  }: Options = {},
): string {
  if (value.length <= headLength + tailLength + ELLIPSIS.length) {
    return value;
  }

  const head = value.slice(0, headLength);
  const tail = value.slice(value.length - tailLength);

  return `${head}${ELLIPSIS}${tail}`;
}
